import {DefaultWizardData} from './DefaultWizardData';
import {isString} from '../../../../../common/types/guards/isString';
import {isArray} from '../../../../../common/types/guards/isArray';

export function isDefaultWizardData(o?: any): o is DefaultWizardData {
    return isString(o?.wizardId)
        && isArray(o?.steps)
        && isString(o?.cancelPage);
}
